function AutoCompleteSearch({
  searchedInsurances,
  selectedInsurance,
  isCompany = false,
  isAdjuster = false,
  isReport = false,
  isReport2 = false,
  isCounsel = false,
  isFirm = false,
  isAgency = false,
}) {
  if (isAdjuster) {
    return (
      <div className="position-relative">
        <div
          id="autocomplete-list"
          className="auto-complete "
          style={{
            position: "absolute",
            zIndex: 1000,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            width: "100%",
            maxHeight: "190px",
            minHeight: "auto",
            overflow: "scroll",
            scrollbarWidth: "none",
            // maxHeight: "150px",
            // overflowY: "auto",
          }}
        >
          {searchedInsurances.length > 0
            ? searchedInsurances.map((adjuster) => {
                const fullAddress =
                  [
                    adjuster?.company_name ? `${adjuster.company_name}` : "",
                    adjuster?.first_name || adjuster?.last_name
                      ? `${adjuster.first_name} ${adjuster.last_name}`
                      : "",
                    adjuster?.address1,
                    adjuster?.address2,
                    adjuster?.city,
                    adjuster?.state,
                    adjuster?.zip,
                  ]
                    .filter(Boolean)
                    .join(", ") + (adjuster?.zip ? "" : "");
                return (
                  <div
                    style={{
                      padding: "0px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                    }}
                    onClick={() => selectedInsurance(adjuster.id)}
                    className="autocomplete- height-25 p-l-5"
                  >
                    {fullAddress}
                  </div>
                );
              })
            : ""}
        </div>
      </div>
    );
  }

  if (isCompany) {
    return (
      <div className="position-relative">
        <div
          id="autocomplete-list"
          className="auto-complete "
          style={{
            position: "absolute",
            zIndex: 1000,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            width: "100%",
            maxHeight: "190px",
            minHeight: "auto",
            overflow: "scroll",
            scrollbarWidth: "none",
          }}
        >
          {searchedInsurances.length > 0
            ? searchedInsurances.map((insurance) => {
                const fullAddress =
                  [
                    insurance?.company_name ? `${insurance.company_name}` : "",
                    insurance?.first_name || insurance?.last_name
                      ? `${insurance.first_name} ${insurance.last_name}`
                      : "",
                    insurance?.address1,
                    insurance?.address2,
                    insurance?.city,
                    insurance?.state,
                    insurance?.zip,
                  ]
                    .filter(Boolean)
                    .join(", ") + (insurance?.zip ? "" : "");
                return (
                  <div
                    style={{
                      padding: "0px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                    }}
                    onClick={() => selectedInsurance(insurance.id)}
                    className="autocomplete- height-25 p-l-5"
                  >
                    {fullAddress}
                  </div>
                );
              })
            : ""}
        </div>
      </div>
    );
  }

  if (isCounsel) {
    return (
      <div className="position-relative">
        <div
          id="autocomplete-list"
          className="auto-complete "
          style={{
            position: "absolute",
            zIndex: 1000,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            width: "100%",
            maxHeight: "190px",
            minHeight: "auto",
            overflow: "scroll",
            scrollbarWidth: "none",
          }}
        >
          {searchedInsurances.length > 0
            ? searchedInsurances.map((insurance) => {
                const fullAddress =
                  [
                    insurance?.office_name ? `${insurance.office_name}` : "",
                    insurance?.first_name || insurance?.last_name
                      ? `${insurance.first_name} ${insurance.last_name}`
                      : "",
                    insurance?.address1,
                    insurance?.address2,
                    insurance?.city,
                    insurance?.state,
                    insurance?.zip,
                  ]
                    .filter(Boolean)
                    .join(", ") + (insurance?.zip ? "" : "");
                return (
                  <div
                    style={{
                      padding: "0px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                    }}
                    onClick={() => selectedInsurance(insurance.id)}
                    className="autocomplete- height-25 p-l-5"
                  >
                    {fullAddress}
                  </div>
                );
              })
            : ""}
        </div>
      </div>
    );
  }

  if (isAgency) {
    return (
      <div className="position-relative">
        <div
          id="autocomplete-list"
          className="auto-complete "
          style={{
            position: "absolute",
            zIndex: 1000,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            width: "100%",
            maxHeight: "190px",
            minHeight: "auto",
            overflow: "scroll",
            scrollbarWidth: "none",
          }}
        >
          {searchedInsurances.length > 0
            ? searchedInsurances.map((insurance) => {
                const fullAddress =
                  [
                    insurance?.agency_name ? `${insurance.agency_name}` : "",
                    insurance?.contact?.first_name || insurance?.contact?.last_name
                      ? `${insurance.contact?.first_name} ${insurance.contact?.last_name}`
                      : "",
                    insurance?.contact?.address1,
                    insurance?.contact?.address2,
                    insurance?.contact?.city,
                    insurance?.contact?.state,
                    insurance?.contact?.zip,
                  ]
                    .filter(Boolean)
                    .join(", ") + (insurance?.contact?.zip ? "" : "");
                return (
                  <div
                    style={{
                      padding: "0px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                    }}
                    onClick={() => selectedInsurance(insurance.id)}
                    className="autocomplete- height-25 p-l-5"
                  >
                    {fullAddress}
                  </div>
                );
              })
            : ""}
        </div>
      </div>
    );
  }

  if (isFirm) {
    return (
      <div className="position-relative">
        <div
          id="autocomplete-list"
          className="auto-complete "
          style={{
            position: "absolute",
            zIndex: 1000,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            width: "100%",
            maxHeight: "190px",
            minHeight: "auto",
            overflow: "scroll",
            scrollbarWidth: "none",
          }}
        >
          {searchedInsurances.length > 0
            ? searchedInsurances.map((insurance) => {
                const fullAddress =
                  [
                    insurance?.first_name || insurance?.last_name
                      ? `${insurance.first_name} ${insurance.last_name}`
                      : "",
                    insurance?.address1,
                    insurance?.address2,
                    insurance?.city,
                    insurance?.state,
                    insurance?.zip,
                  ]
                    .filter(Boolean)
                    .join(", ") + (insurance?.zip ? "" : "");
                return (
                  <div
                    style={{
                      padding: "0px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                    }}
                    onClick={() => selectedInsurance(insurance.id)}
                    className="autocomplete- height-25 p-l-5"
                  >
                    {fullAddress}
                  </div>
                );
              })
            : ""}
        </div>
      </div>
    );
  }

  if (isReport) {
    return (
      <div className="position-relative">
        <div
          id="autocomplete-list"
          className="auto-complete "
          style={{
            position: "absolute",
            zIndex: 1000,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            width: "100%",
            maxHeight: "190px",
            minHeight: "auto",
            overflow: "scroll",
            scrollbarWidth: "none",
          }}
        >
          {searchedInsurances.length > 0
            ? searchedInsurances.map((insurance) => {
                const fullAddress = insurance.reporting_agency;

                return (
                  <div
                    style={{
                      padding: "0px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                    }}
                    onClick={() => selectedInsurance(insurance?.id)}
                    className="autocomplete- height-25 p-l-5"
                  >
                    {fullAddress}
                  </div>
                );
              })
            : ""}
        </div>
      </div>
    );
  }

  if (isReport2) {
    return (
      <div className="position-relative">
        <div
          id="autocomplete-list"
          className="auto-complete "
          style={{
            position: "absolute",
            zIndex: 1000,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            width: "100%",
            maxHeight: "325px",
            minHeight: "auto",
            overflow: "scroll",
            scrollbarWidth: "none",
            top: "-5px",
          }}
        >
          {searchedInsurances.length > 0
            ? searchedInsurances.map((insurance) => {
                // const fullAddress = insurance.reporting_agency;
                const fullAddress =
                  [
                    insurance?.reporting_agency ? `${insurance.reporting_agency}` : "",

                    insurance?.address1,
                    insurance?.address2,
                    insurance?.city,
                    insurance?.state,
                    insurance?.zip,
                  ]
                    .filter(Boolean)
                    .join(", ") + (insurance?.zip ? "" : "");
                return (
                  <div
                    style={{
                      padding: "0px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                    }}
                    onClick={() => selectedInsurance(insurance)}
                    className="autocomplete- height-25 p-l-5"
                  >
                    {fullAddress}
                  </div>
                );
              })
            : ""}
        </div>
      </div>
    );
  } else {
    return (
      <div className="position-relative">
        <div
          id="autocomplete-list"
          className="auto-complete"
          style={{
            position: "absolute",
            zIndex: 1000,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            width: "100%",
            maxHeight: "190px",
            minHeight: "auto",
            overflow: "scroll",
            scrollbarWidth: "none",
          }}
        >
          {searchedInsurances.length > 0
            ? searchedInsurances.map((insurance) => {
                const fullAddress =
                  [
                    insurance?.company_name ? `${insurance.company_name}` : "",
                    insurance?.first_name || insurance?.last_name
                      ? `${insurance.first_name} ${insurance.last_name}`
                      : "",
                    insurance?.address1,
                    insurance?.address2,
                    insurance?.city,
                    insurance?.state,
                    insurance?.zip,
                  ]
                    .filter(Boolean)
                    .join(", ") + (insurance?.zip ? "" : "");
                return (
                  <div
                    style={{
                      padding: "0px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                    }}
                    onClick={() => selectedInsurance(insurance.id)}
                    className="autocomplete- height-25 p-l-5"
                  >
                    {fullAddress}
                  </div>
                );
              })
            : ""}
        </div>
      </div>
    );
  }
}

export default AutoCompleteSearch;
